import type { ComponentProps } from "react";
import BaseActionButton from "./BaseActionButton";

type DownloadButtonProps = Omit<
    ComponentProps<typeof BaseActionButton>,
    "iconType" | "testId" | "buttonType" | "label" | "loadingText"
> & {
    label?: string;
    loadingText?: string;
    buttonType?: "submit" | "button";
    variant?: ComponentProps<typeof BaseActionButton>["variant"];
};

const DownloadButton = ({
    label = "Download",
    loadingText = "Downloading...",
    buttonType = "button",
    variant = "outline",
    ...props
}: DownloadButtonProps) => {
    return (
        <BaseActionButton
            label={label}
            loadingText={loadingText}
            iconType="download"
            testId="download-button"
            buttonType={buttonType}
            variant={variant}
            {...props}
        />
    );
};

export default DownloadButton;
